import defaultTheme from 'tailwindcss/defaultTheme';
const screens = {
    screens: {
        ...defaultTheme.screens,
        xxs: '350px',
        xs: '520px',
        // sm: '640px', //default
        // md: '768px', // default
        mdlg: '896px',
        // lg: '1024px', //default
        lgxl: '1152px'
        // xl: '1280px', //default
        // '2xl': '1536px', //default
    }
};
export default screens;
